import React, { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

export default function Dropdown({
  trigger,
  items = [],
  align = 'right',
  className = ''
}) {
  const alignmentClasses = {
    left: 'left-0 rtl:left-auto rtl:right-0',
    right: 'right-0 rtl:right-auto rtl:left-0'
  };
  
  return (
    <Menu as="div" className={`relative inline-block text-left ${className}`}>
      <Menu.Button as={Fragment}>
        {trigger || (
          <button className="btn-outline">
            Options
            <ChevronDownIcon className="w-4 h-4 ml-2" />
          </button>
        )}
      </Menu.Button>
      
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className={`dropdown ${alignmentClasses[align]}`}>
          {items.map((item, index) => {
            if (item.divider) {
              return <div key={index} className="border-t border-gray-100 my-1" />;
            }
            
            return (
              <Menu.Item key={index}>
                {({ active }) => (
                  <button
                    onClick={item.onClick}
                    disabled={item.disabled}
                    className={`dropdown-item w-full text-left rtl:text-right flex items-center gap-2 ${
                      active ? 'bg-gray-50' : ''
                    } ${item.danger ? 'text-danger' : ''} ${item.disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
                  >
                    {item.icon && <item.icon className="w-4 h-4" />}
                    {item.label}
                  </button>
                )}
              </Menu.Item>
            );
          })}
        </Menu.Items>
      </Transition>
    </Menu>
  );
}
